import Route from '@ember/routing/route';

export default class MarketSettingsPersonalRoute extends Route {}
